import { State } from "easy-peasy";
import { useLocation } from "react-router-dom";
import { CurrentUserModel } from "src/models/currentUser";
import { dashboardWorkspace } from "src/utils/dashboardWorkspace";

export type UserKindContext =
  | "signedOut"
  | "client"
  | "agent"
  | "talent"
  | "TPA";

export const useUserKindContext = (
  currentUser: State<CurrentUserModel>,
): UserKindContext => {
  const { pathname } = useLocation();
  const workspace = dashboardWorkspace(pathname, currentUser);
  if (workspace === "client") {
    return "client";
  }

  if (workspace === "agent" && !currentUser.isFirstPartyAgent) {
    return "TPA";
  }

  if (workspace === "agent") {
    return "agent";
  }

  if (workspace === "talent") {
    return "talent";
  }

  return "signedOut";
};
